import { memo, ReactElement, useCallback, useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Switch } from '@cbhq/cds-web/controls';

import { useProfileMenuV2 } from '../providers/ProfileMenuV2Provider';

import { ActionItem as UserSwitcherActionItem } from './UserSwitcher/ActionItem';
import { ActionItem } from './ActionItem';

type TogglerActionItemProps = {
  callback: () => void;
  icon: ReactElement;
  label: string;
  toggleValue?: boolean;
};

const messages = defineMessages({
  toggleMode: {
    id: 'TogglerAction.toggleMode',
    defaultMessage: 'Toggle from {fromMode} to {toMode} mode',
  },
});

export const TogglerActionItem = memo(
  ({ callback, icon, label, toggleValue = false }: TogglerActionItemProps) => {
    const { userSwitcherEnabled } = useProfileMenuV2();
    const { formatMessage } = useIntl();

    const handleActionClick = useCallback(() => {
      callback();
    }, [callback]);

    const toggler = useMemo(() => {
      return (
        <Switch
          onChange={handleActionClick}
          checked={toggleValue}
          onClick={handleActionClick}
          accessibilityLabel={formatMessage(messages.toggleMode, {
            fromMode: toggleValue ? 'dark' : 'light',
            toMode: toggleValue ? 'light' : 'dark',
          })}
        />
      );
    }, [formatMessage, handleActionClick, toggleValue]);
    if (userSwitcherEnabled) {
      return (
        <UserSwitcherActionItem
          label={label}
          icon={icon}
          onPress={handleActionClick}
          end={toggler}
        />
      );
    }

    return <ActionItem label={label} icon={icon} onPress={handleActionClick} end={toggler} />;
  },
);
